module.exports = __webpack_public_path__ + "assets/static/png/service-cell-icon-1.6541894937c377f479ef74c61bbd46bf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/service-cell-icon-1.png
 ** module id = 7
 ** module chunks = 1
 **/